import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted } from 'vue';
import { formatDistance } from 'date-fns';
import IListItem from '../interfaces/IListItem';
import Trash from './icons/Trash.vue';
import Check from './icons/Check.vue';

export default /*#__PURE__*/_defineComponent({
  props: {
  result: {
    type: Object as () => IListItem,
    required: true,
  },
  matches: Boolean,
},
  emits: ['delete'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props



const { content, id, createdAt } = ref(props.result).value;

const formatTime = (date: Date) =>
  formatDistance(date, new Date(), { addSuffix: true });

const timeAgo = ref(formatTime(new Date(createdAt)));

// bonus points for realtime
// add a ticker to update the timeAgo every minute
// TODO: only update the value when it needs to be updated
let interval: any = null;
onMounted(() => {
  interval = setInterval(() => {
    timeAgo.value = formatTime(new Date(createdAt));
  }, 1000 * 60);
});
//clear the ticker when the component is unmounted
onUnmounted(() => {
  clearInterval(interval);
});

const __returned__ = { props, emit, content, id, createdAt, formatTime, timeAgo, interval, ref, onMounted, onUnmounted, formatDistance, IListItem, Trash, Check }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})